function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import set from 'lodash/set';
import ReactResizeDetector from 'react-resize-detector';
import componentPropType from '@signal/prop-types/component';
import renderIf from '@signal/utils/renderIf';
import { getColorScalePrimarySelector } from '@signal/theme/selectors';
import TypographySkeleton from '../Skeleton/Typography';
import Legend from '../Legend';
import { stackedBarChartSeriesPropType } from '../StackedBarChart';
import StackedBarChartSkeleton from '../StackedBarChart/Skeleton';
import { Wrapper, ChartWrapper } from './styles';
export default function StackedBarChartWithLegendSkeleton(_ref) {
  var hasDescription = _ref.hasDescription,
      hideLegend = _ref.hideLegend,
      series = _ref.series,
      chartWrapperProps = _ref.chartWrapperProps,
      descriptionProps = _ref.descriptionProps,
      pattern = _ref.pattern,
      rest = _objectWithoutProperties(_ref, ["hasDescription", "hideLegend", "series", "chartWrapperProps", "descriptionProps", "pattern"]);

  var skeletonSeries = series.map(function (row, i) {
    return set(row, 'label', "skeleton_".concat(i));
  });
  return /*#__PURE__*/React.createElement(Wrapper, rest, renderIf(!hideLegend, function () {
    return /*#__PURE__*/React.createElement(Legend, {
      series: skeletonSeries,
      labelComponent: TypographySkeleton,
      labelProps: {
        width: 70
      }
    });
  }), /*#__PURE__*/React.createElement(ReactResizeDetector, {
    handleWidth: true
  }, function (dimensions) {
    return /*#__PURE__*/React.createElement(ChartWrapper, chartWrapperProps, /*#__PURE__*/React.createElement(StackedBarChartSkeleton, Object.assign({
      pattern: pattern,
      series: skeletonSeries
    }, dimensions)));
  }), renderIf(hasDescription, function () {
    return /*#__PURE__*/React.createElement(TypographySkeleton, Object.assign({}, descriptionProps, {
      style: Object.assign({}, {
        maxWidth: '300px'
      }, descriptionProps.style)
    }));
  }));
}
StackedBarChartWithLegendSkeleton.propTypes = {
  hasDescription: PropTypes.bool,
  hideLegend: PropTypes.bool,
  series: stackedBarChartSeriesPropType,
  chartWrapperProps: PropTypes.object,
  descriptionProps: PropTypes.object,
  pattern: componentPropType
};
StackedBarChartWithLegendSkeleton.defaultProps = {
  series: [{
    value: 50,
    fill: getColorScalePrimarySelector(7)
  }, {
    value: 50,
    fill: getColorScalePrimarySelector(4)
  }],
  chartWrapperProps: {},
  descriptionProps: {}
};